import { useSelector } from 'react-redux';

const useUserData = () => {
  const userData = useSelector((state) => state);
  return userData.generalInformation;
};
export default useUserData;
